import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import { accountShape, branchShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { AlertInfo } from '@bibliocommons/deprecated-base-alerts';
import fieldErrorWrapper from '@bibliocommons/shared-field-error-wrapper';
import './PickupBranchSelect.scss';

class PickupBranchSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getSelectedBranchName() {
    const selected = this.props.branches.find(b => b.get('code') === this.props.selectedBranch);
    // TODO: This needs to be determined by a setting
    return selected ? selected.get('name') : this.props.intl.formatMessage({ id: 'form_label_select_a_branch' });
  }

  getOptions() {
    const { branches, preferredBranches } = this.props;
    const indexedPreferred = Immutable.Map(preferredBranches.map(branch => [branch.get('code'), branch]));
    const nonPreferredBranches = branches.filter(branch => !indexedPreferred.get(branch.get('code')));

    const getOption = branch => ({
      key: branch.get('code'),
      label: branch.get('name'),
      value: branch.get('code')
    });

    const preferredOptions = preferredBranches.map(getOption);
    const nonPreferredOptions = nonPreferredBranches.map(getOption);

    if (preferredOptions.size > 0) {
      return preferredOptions.concat(
        {
          key: 'preferred-branch-divider',
          divider: true
        },
        nonPreferredOptions
      );
    }

    return nonPreferredOptions;
  }

  handleSelect(value) {
    this.props.handleSelect(this.props.branches.find(b => b.get('code') === value));
  }

  renderSelectPickupPrompt() {
    const { selectedBranch, currentAccount, preferredBranches } = this.props;
    const preferredLocations = currentAccount.get('preferredLocations', Immutable.List());

    if (!selectedBranch && preferredBranches.size === 0 && preferredLocations.size > 0) {
      return (
        <AlertInfo>
          <FormattedMessage id="reselect_pickup_location_prompt" />
        </AlertInfo>
      );
    }

    return null;
  }

  render() {
    const { label } = this.props;

    return (
      <span className="cp-pickup-branch-select">
        {label && <span className="col-12 col-xs-12 col-sm-4 control-label">{label}</span>}
        <div className="column-input-group col-12 col-xs-12 col-sm-8">
          {this.renderSelectPickupPrompt()}
          <Dropdown
            defaultValue={this.props.intl.formatMessage({
              id: 'form_label_select_a_branch'
            })}
            dataKey="pickup-branch-select-dropdown"
            fieldErrors={this.props.fieldErrors}
            errorKey="physicalParams.branchId"
            selected={this.getSelectedBranchName()}
            options={this.getOptions()}
            handleSelect={this.handleSelect}
            labelLocalizedText={label}
            descriptionLocalizedText={label}
            className="btn-default btn-flat"
          />
        </div>
      </span>
    );
  }
}

PickupBranchSelect.propTypes = {
  label: PropTypes.string,
  fieldErrors: PropTypes.objectOf(
    PropTypes.shape({
      classification: PropTypes.string,
      message: PropTypes.string
    })
  ),
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  currentAccount: accountShape.isRequired,
  handleSelect: PropTypes.func.isRequired,
  selectedBranch: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

PickupBranchSelect.displayName = 'PickupBranchSelect';

export default injectIntl(fieldErrorWrapper(PickupBranchSelect));
